/**
 * 
 */
 import React from 'react'
 
 export default function Paragraph(props){
	return (<p className={props.class}> {props.text} </p>);
 };